import { Link } from 'react-router-dom'
import styled from 'styled-components'

type StyledProps = {
  $completed?: boolean
  $current?: boolean
}

const StyledLessonSidebarLesson = styled(Link)<StyledProps>`
  display: flex;
  align-items: center;
  user-select: none;
  text-decoration: none;
  padding: 6px;
  border-radius: 6px;
  transition: 0.2s;
  margin: -6px;
  position: relative;

  .lesson-status {
    position: relative;
    flex-shrink: 0;
    display: flex;
    margin-right: 14px;

    .lesson-status-btn {
      height: 22px;
      width: 22px;
      border-radius: 50%;
      background-color: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${({ theme }) => theme.color.background};
      box-shadow: inset 0 0 0 2px ${({ theme }) => theme.color.gray[400]};

      svg {
        height: 12px;
        stroke-width: 4px;
      }

      ${({ $current, theme }) =>
        $current &&
        `
        &::after {
          content: '';
          height: 8px;
          width: 8px;
          border-radius: 50%;
          background-color: ${theme.color.gray[400]};
        }
      `}

      ${({ $completed, theme }) =>
        $completed &&
        `
        background-color: ${theme.color.green[700]};
        box-shadow: inset 0 0 0 2px ${theme.color.green[700]};
      `}

      ${({ $completed, $current, theme }) =>
        $completed &&
        $current &&
        `
        &::after {
          background-color: ${theme.color.background};
        }
      `}
    }
  }

  .lesson-title {
    width: 100%;
    font-size: 13px;
    font-weight: 500;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-align: left;
    -webkit-box-orient: vertical;
    color: ${({ theme }) => theme.color.gray[600]};

    ${({ $current, theme }) =>
      $current &&
      `
        color: ${theme.color.gray[900]};
      `}
  }

  .lesson-length {
    font-size: 13px;
    color: ${({ theme }) => theme.color.gray[600]};
    white-space: nowrap;
    margin-left: 14px;
    flex-shrink: 0;

    ${({ $current, theme }) =>
      $current &&
      `
        color: ${theme.color.gray[900]};
      `}
  }

  &:hover {
    background-color: ${({ theme }) => theme.color.gray[200]};
  }

  &:not(:last-child) {
    .lesson-status::before {
      content: '';
      z-index: 1;
      position: absolute;
      background-color: ${({ theme }) => theme.color.gray[400]};
      left: 50%;
      transform: translateX(-50%);
      height: 12px;
      width: 2px;
      top: 100%;

      ${({ $completed, theme }) =>
        $completed &&
        `
        background-color: ${theme.color.green[700]};
      `}
    }
  }

  ${({ $current, theme }) =>
    $current &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: -8px;
      transform: translateY(-50%);
      height: 22px;
      background-color: ${theme.color.gray[900]};
      width: 3px;
      border-radius: 0 50rem 50rem 0;
    }
  `}
`

export default StyledLessonSidebarLesson
